// Copyright (c) 2025 TrustCloud Corporation - All rights reserved.
//
// This software contains valuable confidential and proprietary information of
// TrustCloud Corporation
//
// Unauthorized use, reproduction, transmission, or distribution of this file and its
// contents is a violation of applicable law.

import styled from '@emotion/styled';

export const Hero = styled.header`
  background-color: #032d42;
  grid-area: hero;

  padding-top: 12rem;
`;

export const HeroProgramContentContainer = styled.div`
  display: flex;
  flex-direction: column;

  isolation: isolate;
  position: relative;
  margin-bottom: 10rem;

  width: 100%;
  margin-left: auto;
  margin-right: auto;

  padding: 0 4rem 96px 4rem;

  & .hero-header {
    span {
      color: ${({ theme }) => theme.components.button.background.primary};
    }
  }
`;

export const PrimarySectionGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;

  width: calc(100% - 8rem);

  & .primary-section-list-item {
    & > div {
      height: 100%;
    }
  }

  & .primary-section-list-item-title {
    font-weight: 600;
  }

  & .primary-section-list-item-description {
    display: -webkit-box;
    overflow: hidden;
    line-clamp: 3;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;

    font-weight: 500;
    font-family: Lato;
  }

  & .primary-section-list-item-actions {
    padding-top: 8px;

    margin-top: auto;
  }
`;

export const PrimarySectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  width: 100%;
  position: absolute;
  top: 100%;

  & h4 {
    text-align: center;
  }
`;
